// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_REPORT_ARTICLE = "Nahl\u00e1si\u0165 \u010dl\u00e1nok";
export const CHANGE_ARTICLE = "Uprav \u010dl\u00e1nok";
export const DELETE_ARTICLE = "Zma\u017e \u010dl\u00e1nok";
export const REMOVE_FROM_FEED = "Odstr\u00e1ni\u0165 z feedu";
export const RETURN_TO_FEED = "Vr\u00e1ti\u0165 do feedu";
export const SEO_TITLE_BLOGS_article = "%(article)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017e\u00edvate\u013eky, ktor\u00fdm sa to p\u00e1\u010di";
